/**
 * 应用实例领域类型（交付插件 SoT；已 registerDeployPlugin）。
 * pages 侧 `app-instance/types` 对此 re-export，避免插件 import @/pages。
 */
import type { MaasGroupedWorkloadSpec, MaasInstanceFormValues } from '@/delivery-type-plugin/capabilities/maas-init';

/** 应用实例默认数据盘挂载路径（无模型配置） */
export const DEFAULT_APP_DATA_MOUNT_PATH = '/data';

/** 与后端 ApplicationInstanceSpec 对齐（无 model 字段） */
export type ApplicationInstanceSpec = MaasGroupedWorkloadSpec;

/** 创建/编辑表单（共用 UI 字段见 MaasInstanceFormValues） */
export interface ApplicationInstanceFormValues extends MaasInstanceFormValues {
  /** UI：数据盘挂载路径（首条，兼容旧逻辑） */
  dataMountPath?: string;
  /** UI：多组挂载路径与数据盘（JSON 字符串） */
  _appStorageGroups?: string;
  /** 实例级镜像拉取账密，提交时写入各节点组 registry */
  registry?: { server?: string; username?: string; password?: string };
}
